import { Fragment, useEffect, useState } from "react";
import styles from "./ExpenseRecovery.module.css";

const ExpenseRecovery = () => {
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [selectedMonth,setSelectedmonth]=useState("")

  const generateYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  };

  const months = [
    { name: "January", status: "GenerateReport" },
    { name: "February", status: "GenerateReport" },
    { name: "March", status: "GenerateReport" },
    { name: "April", status: "GenerateReport" },
    { name: "May", status: "ReportGenerated" },
    { name: "June", status: "Skipped" },
    { name: "July", status: "Skipped" },
    { name: "August", status: "ReportGenerated" },
    { name: "September", status: "ReportGenerated" },
    { name: "October", status: "Skipped" },
    { name: "November", status: "Skipped" },
    { name: "December", status: "Skipped" },
  ];

  useEffect(() => {
    const startYear = 2020;
    setYearOptions(generateYearOptions(startYear));
  }, []);

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleGenerateReport = (month) => {
    setSelectedmonth(month)
    console.log(`Generating report for ${month} ${selectedYear}`);
    setOpenModel(true);
  };

  const handleDownloadReport = (month) => {
    setSelectedmonth(month)
    console.log(`Downloading report for ${month} ${selectedYear}`);
    setOpenModel(true);
  };

  const handleReportSkipped = (month) => {
    console.log(`Report skipped for ${month} ${selectedYear}`);
    // Add actual skip logic here (e.g., update status)
  };

  const CreateAndDownloadCsv = () => {
    setOpenModel(false);
  };

  return (
    <Fragment>
      <div className={styles.Container}>
        <div className={styles.ContainerHeading}>
          Generate Expense Recovery Report
        </div>
        <div>
          <select
            className={styles.Filter}
            value={selectedYear}
            onChange={handleYearChange}
          >
            <option value="" selected disabled>
              Select Year
            </option>
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        {selectedYear ? (
          <div className={styles.TableContainer}>
            <table className={styles.ReportTable}>
              <tbody className={styles.TableBody}>
                {months.map((month) => (
                  <tr key={month.name} className={styles.TableRow}>
                    <td className={styles.TableMonth}>{month.name}</td>
                    <td className={styles.TableButton}>
                      {month.status === "GenerateReport" && (
                        <button
                          className={styles.GenerateButton}
                          onClick={() => handleGenerateReport(month.name)}
                        >
                          Generate
                        </button>
                      )}
                      {month.status === "ReportGenerated" && (
                        <button
                          className={styles.GenerateButton}
                          onClick={() => handleDownloadReport(month.name)}
                        >
                          Download
                        </button>
                      )}
                      {month.status === "Skipped" && (
                        <button
                          className={styles.SkippedButton}
                          onClick={() => handleReportSkipped(month.name)}
                        >
                          Report Skipped
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={styles.NoTableData}>
            This report contains the list of users and the total amount of their
            rejected transactions, which is to be recovered from them.
          </div>
        )}
      </div>
      {openModel && (
        <div
          className={styles.model}
          onClick={() => {
            setOpenModel(false);
          }}
        >
          <button
            className={styles.model1}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div
              className={styles.modelHeading}
            >{`Generate ${selectedMonth} Report?`}</div>
            <div className={styles.modelContainer}>
              <div className={styles.modelContainerWarning}>
                <img
                  className={styles.escrowLogo}
                  alt=""
                  src="/Exclamation-orange-icon.svg"
                />
                This report can only be generated once this month. All
                rejections after this will go to next month.
              </div>
              <div className={styles.modelContainerFileInfo}>
                <img
                  className={styles.escrowLogo1}
                  alt=""
                  src="/csv-file-icon.svg"
                />
                {`${selectedYear} ${selectedMonth} report`}
              </div>
              <div className={styles.modelContainerButton}>
                <button
                  className={styles.CancelButton}
                  onClick={() => {
                    setOpenModel(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className={styles.ConfirmButton}
                  onClick={() => {
                    CreateAndDownloadCsv();
                  }}
                >
                  Confirm & Download
                </button>
              </div>
            </div>
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default ExpenseRecovery;
